import React from 'react';
import GoogleMapReact from 'google-map-react';
import LocationMarker from './LocationMarker';
const Map = ({ eventData, center, zoom, selected }) => {
  const markers = eventData.map((ev) => {
    if (ev.geometry[0].type === 'Point') {
      return ev.geometry.map((geo) => {
        return (
          <LocationMarker
            lat={geo.coordinates[1]}
            lng={geo.coordinates[0]}
            type={ev.categories[0].id}
            selected={selected}
            onClick={() =>
              alert(
                ev.title +
                  '\n' +
                  'To Know more about this event goto: ' +
                  '\n' +
                  ev.link
              )
            }
          />
        );
      });
    } else return null;
  });
  return (
    <div className='map'>
      <GoogleMapReact
        bootstrapURLKeys={{ key: 'AIzaSyArxWp7O0R71w9kkzuEMA-NexOl7p7OWrA' }}
        defaultCenter={center}
        defaultZoom={zoom}
      >
        {markers}
      </GoogleMapReact>
    </div>
  );
};

Map.defaultProps = {
  center: {
    lat: 42.3265,
    lng: -122.8756,
  },
  selected: [],
  zoom: 2,
};

export default Map;
